import React, { useState } from "react";

const questionsData = [
  {
    question: "Que signifie le terme 'Hajime' en arbitrage de judo ?",
    options: ["Début du combat", "Arrêt temporaire", "Fin du combat"],
    correctAnswer: "Début du combat",
  },
  {
    question: "Combien de temps une immobilisation doit durer pour un Ippon ?",
    options: ["10 secondes", "20 secondes", "15 secondes"],
    correctAnswer: "20 secondes",
  },
  {
    question: "Que signifie 'Matte' ?",
    options: ["Arrêt temporaire du combat", "Début d'une immobilisation", "Fin du combat"],
    correctAnswer: "Arrêt temporaire du combat",
  },
  {
    question: "Qu'est-ce qu'un 'Hansoku-make' ?",
    options: ["Un avantage léger", "Une disqualification", "Une pénalité mineure"],
    correctAnswer: "Une disqualification",
  },
  {
    question: "Quelle est la pénalité pour une fausse attaque répétée ?",
    options: ["Shido", "Waza-ari", "Hansoku-make"],
    correctAnswer: "Shido",
  },
  {
    question: "Que signifie 'Sore-made' en arbitrage de judo ?",
    options: ["Début du combat", "Fin du combat", "Pause du combat"],
    correctAnswer: "Fin du combat",
  },
  {
    question: "Quelle durée d'immobilisation donne un Waza-ari ?",
    options: ["10 à 19 secondes", "20 secondes", "5 à 9 secondes"],
    correctAnswer: "10 à 19 secondes",
  },
  {
    question: "Que signifie 'Osaekomi' ?",
    options: [
      "Début d'une immobilisation",
      "Fin d'une immobilisation",
      "Arrêt temporaire",
    ],
    correctAnswer: "Début d'une immobilisation",
  },
  {
    question: "Combien de Shido entraînent une disqualification ?",
    options: ["3 Shido", "2 Shido", "4 Shido"],
    correctAnswer: "3 Shido",
  },
  {
    question: "Quel geste est utilisé pour signaler une pénalité Shido ?",
    options: [
      "Un bras tendu horizontalement",
      "Les deux bras croisés sur la poitrine",
      "Pointer avec l'index tendu",
    ],
    correctAnswer: "Pointer avec l'index tendu",
  },
  {
    question: "Que signifie 'Toketa' ?",
    options: [
      "Début d'une immobilisation",
      "Fin d'une immobilisation",
      "Arrêt temporaire",
    ],
    correctAnswer: "Fin d'une immobilisation",
  },
  {
    question: "Quelle est la durée d'un combat chez les Minimes ?",
    options: ["2 minutes", "3 minutes", "4 minutes"],
    correctAnswer: "3 minutes",
  },
  {
    question: "Que signifie 'Golden Score' ?",
    options: [
      "Une pénalité décisive",
      "Prolongation illimitée jusqu'à un score",
      "Fin immédiate du combat",
    ],
    correctAnswer: "Prolongation illimitée jusqu'à un score",
  },
  {
    question: "Qu'est-ce qu'un Hansoku-make grave ?",
    options: [
      "3 Shido",
      "Action contraire à l'esprit du judo",
      "Sortie volontaire de la zone de combat",
    ],
    correctAnswer: "Action contraire à l'esprit du judo",
  },
  {
    question: "Que signifie 'Kinza' en arbitrage ?",
    options: [
      "Avantage léger",
      "Pénalité mineure",
      "Point complet",
    ],
    correctAnswer: "Avantage léger",
  },
  {
    question: "Quelle est la pénalité pour une saisie illégale ?",
    options: ["Shido", "Hansoku-make", "Waza-ari"],
    correctAnswer: "Shido",
  },
  {
    question: "Combien de Waza-ari équivalent à un Ippon ?",
    options: ["2", "3", "1"],
    correctAnswer: "2",
  },
  {
    question: "Quel est le rôle principal des commissaires sportifs ?",
    options: [
      "Attribuer des pénalités",
      "Enregistrer les points et le temps",
      "Demander l'équipe médicale",
    ],
    correctAnswer: "Enregistrer les points et le temps",
  },
  {
    question: "Quelle est la durée maximale d'un Golden Score ?",
    options: [
      "Aucune limite",
      "1 minute",
      "5 minutes",
    ],
    correctAnswer: "Aucune limite",
  },
  {
    question: "Quelle action entraîne un Hansoku-make immédiat ?",
    options: [
      "Fausse attaque",
      "Pratiquer une technique interdite",
      "Sortie volontaire de la zone",
    ],
    correctAnswer: "Pratiquer une technique interdite",
  },
  {
    question: "Que signifie 'Matte' ?",
    options: [
      "Arrêt temporaire du combat",
      "Début du combat",
      "Fin du combat",
    ],
    correctAnswer: "Arrêt temporaire du combat",
  },
  {
    question: "Quel est le temps d'immobilisation pour un Ippon ?",
    options: ["20 secondes", "10 secondes", "30 secondes"],
    correctAnswer: "20 secondes",
  },
  {
    question: "Que signifie 'Hansoku-make' ?",
    options: ["Disqualification", "Demi-point", "Point complet"],
    correctAnswer: "Disqualification",
  },
  {
    question: "Que doit faire un arbitre en cas de divergence sur un point ?",
    options: [
      "Consulter ses arbitres assistants ou vidéo",
      "Ignorer la divergence",
      "Reprendre le combat sans décision",
    ],
    correctAnswer: "Consulter ses arbitres assistants ou vidéo",
  },
  {
    question: "Quelle action est sanctionnée par un Shido ?",
    options: [
      "Fausse attaque",
      "Immobilisation incorrecte",
      "Technique parfaite",
    ],
    correctAnswer: "Fausse attaque",
  },
  {
    question: "Quelle est la durée d'un combat pour les Benjamins ?",
    options: ["1 minute 30", "2 minutes", "3 minutes"],
    correctAnswer: "2 minutes",
  },
  {
    question: "Que signifie 'Osaekomi' ?",
    options: [
      "Début d'une immobilisation",
      "Fin d'une immobilisation",
      "Arrêt temporaire",
    ],
    correctAnswer: "Début d'une immobilisation",
  },
  {
    question: "Que fait l'arbitre avec un 'Shido' ?",
    options: [
      "Donne une pénalité mineure",
      "Interrompt le combat",
      "Accorde un demi-point",
    ],
    correctAnswer: "Donne une pénalité mineure",
  },
  {
    question: "Quelle est la durée d'un combat pour les poussins ?",
    options: ["1 minute", "1 minute 30", "2 minutes"],
    correctAnswer: "1 minute 30",
  },
  {
    question: "Que signifie 'Toketa' ?",
    options: [
      "Fin d'une immobilisation",
      "Arrêt temporaire",
      "Début du combat",
    ],
    correctAnswer: "Fin d'une immobilisation",
  },
  {
    question: "Que doit faire l'arbitre en cas d'insulte ?",
    options: [
      "Attribuer un Hansoku-make",
      "Attribuer un Shido",
      "Ignorer l'incident",
    ],
    correctAnswer: "Attribuer un Hansoku-make",
  },
  {
    question: "Que signifie 'Hajime' ?",
    options: [
      "Début du combat",
      "Pause temporaire",
      "Fin du combat",
    ],
    correctAnswer: "Début du combat",
  },
  {
    question: "Combien de secondes pour un Kinza au sol ?",
    options: [
      "0-9 secondes en animation",
      "10 secondes",
      "15 secondes",
    ],
    correctAnswer: "0-9 secondes en animation",
  },
  {
    question: "Quelle sanction suit 3 Shido consécutifs ?",
    options: [
      "Hansoku-make",
      "Waza-ari",
      "Kinza",
    ],
    correctAnswer: "Hansoku-make",
  },
  {
    question: "Que signifie 'Sore-made' ?",
    options: [
      "Fin du combat",
      "Pause temporaire",
      "Début du combat",
    ],
    correctAnswer: "Fin du combat",
  },
  {
    question: "Comment désigne-t-on un avantage léger en judo ?",
    options: ["Kinza", "Shido", "Waza-ari"],
    correctAnswer: "Kinza",
  },
  {
    question: "Qu'est-ce qu'un 'Shido' ?",
    options: [
      "Pénalité mineure",
      "Demi-point",
      "Point complet",
    ],
    correctAnswer: "Pénalité mineure",
  },
  {
    question: "Que doit faire un arbitre avec un Hansoku-make ?",
    options: [
      "Disqualifier le judoka",
      "Attribuer un demi-point",
      "Ignorer l'infraction",
    ],
    correctAnswer: "Disqualifier le judoka",
  },
  {
    question: "Quelle est la durée de combat pour les cadets (1D) ?",
    options: ["4 minutes", "3 minutes", "5 minutes"],
    correctAnswer: "4 minutes",
  },
];


const ArbitrageQuizz = () => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [showResults, setShowResults] = useState(false);
  const [errors, setErrors] = useState([]);

  // Initialisation des questions
  React.useEffect(() => {
    const shuffledQuestions = questionsData.sort(() => Math.random() - 0.5).slice(0, 10);
    setQuestions(shuffledQuestions);
  }, []);

  const handleAnswer = (answer) => {
    const current = questions[currentQuestion];

    if (answer === current.correctAnswer) {
      setScore(score + 1);
    } else {
      setErrors([...errors, { ...current, selected: answer }]);
    }

    if (currentQuestion === questions.length - 1) {
      setShowResults(true);
    } else {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const handleRestart = () => {
    setScore(0);
    setCurrentQuestion(0);
    setShowResults(false);
    setErrors([]);
    const shuffledQuestions = questionsData.sort(() => Math.random() - 0.5).slice(0, 10);
    setQuestions(shuffledQuestions);
  };

  const progressPercentage = ((currentQuestion + 1) / questions.length) * 100;

  return (
    <div className="w-full pt-[100px] font-satoshi">
      <div className="bg-black bg-opacity-50 p-4 max-w-[1280px] mx-auto">
        <h1 className="text-2xl font-bold text-white font-satoshi">
          Quizz Arbitrage
        </h1>
      </div>

      {showResults ? (
        <div className="max-w-[1280px] mx-auto p-6 font-satoshi">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold">Résultats</h2>
              <p className="text-lg">Score : {score} / 10</p>
            </div>
            <button
              className="btn bg-blueprimary hover:bg-blueprimarylight mt-4"
              onClick={handleRestart}
            >
              Recommencer
            </button>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-6">
            {questions.map((question, index) => {
              const userAnswer = errors.find(
                (error) => error.question === question.question
              )?.selected;

              const isCorrect = !userAnswer;

              return (
                <div
                  key={index}
                  className={`p-4 border rounded-md ${
                    isCorrect
                      ? "bg-green-200 border-green-500"
                      : "bg-red-200 border-red-500"
                  }`}
                >
                  <p className="text-center font-bold text-lg dark:text-gray-800">
                    {question.question}
                  </p>
                  <p className="text-center mt-2">
                    {isCorrect ? (
                      <span className="text-green-800">
                        {question.correctAnswer}
                      </span>
                    ) : (
                      <>
                        <span className="line-through text-red-800">
                          {userAnswer}
                        </span>
                        <br />
                        <span className="text-green-800">
                          {question.correctAnswer}
                        </span>
                      </>
                    )}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="max-w-[1280px] mx-auto p-6">
          {questions.length && (
            <>
              <div className="mb-4">
                <p className="text-lg font-bold">
                  Question {currentQuestion + 1} / {questions.length}
                </p>
                <div className="w-full bg-blueprimarylight h-4 rounded-md overflow-hidden my-2">
                  <div
                    className="bg-blueprimary h-4 rounded-md"
                    style={{ width: `${progressPercentage}%` }}
                  ></div>
                </div>
                <p className="text-center text-lg">
                  {questions[currentQuestion].question}
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 font-satoshi font-semibold">
                {questions[currentQuestion].options.map((option, index) => (
                  <button
                    key={index}
                    style={{
                      fontSize: "18px",
                      padding: "12px",
                    }}
                    className="btn bg-blueprimary hover:bg-blueprimarylight w-full"
                    onClick={() => handleAnswer(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ArbitrageQuizz;
